/*
 * Copyright (c) Nexign, JSC, 2021-2022.
 */
/**
 * Account Info General Tab component styles
 *
 * @author Yakov Gushchin
 * @version 1.16.1
 * @since 1.11.0
 */

import styled from 'styled-components';

import { colors } from '../../../../theme';

export const AccountInfoGeneralStyled = styled.div.attrs({
    className: 'account-info-general',
})`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 32px;
`;

export const AccountInfoGeneralInfoGroupStyled = styled.div.attrs({
    className: 'account-info-general__info-group',
})`
    display: flex;
    flex-direction: column;
    margin-bottom: 24px;

    .account-info-general__title {
        margin-top: 4px;
        color: ${colors.textColorOpacity};
    }
`;

export const AccountInfoGeneralInfoBlockStyled = styled.div.attrs({
    className: 'account-info-general__info-block',
})`
    width: 80%;
    margin-bottom: 24px;
`;
